import { ApexAxisChartSeries } from 'ngx-apexcharts';

export enum CardType {
  focusCard = 'focusCard',
  report = 'report',
  tableau = 'tableau',
  map = 'map',
  work = 'work'
}

export interface IBaseTileItem {
  tileAligment: 'left' | 'right' | 'center';
}

export interface ITextTileStyles {
  titleStyle?: { [key: string]: string };
  legendStyle?: { [key: string]: string };
}

export interface ITextTileData extends IBaseTileItem {
  title: string;
  legend: string;
  config?: {
    sourceName: string;
    sourceDescription: string;
  };
}

export interface IDynamicTileData extends IBaseTileItem {
  dynamicText?: string[];
  dynamicLanguage?: string[];
  itemStyleOutput?: {
    [key: string]: string
  }
}

export interface IRadialBarChartData extends IBaseTileItem {
  series: number[];
  colors: string[];
  title: string;
}

export interface ITextTitleListData extends IBaseTileItem {
  title: string;
  list: ITextTileData[];
}

export interface IKPIData extends IBaseTileItem {
  title: string;
  value: string;
  frame: string;
  value_color: string;
}

export interface ITable extends IBaseTileItem {
  columns: Array<{
    key: string;
    label: string;
    main?: boolean;
    config: {
      type: 'string' | 'boolean' | 'number';
      wrap: 'truncate' | 'nowrap' | 'wrap';
      alignment: 'left' | 'right' | 'center';
    };
  }>;
  rows: Array<{
    cells: {
      [key: string]: {
        value: string;
        textColour:  string | undefined;
      };
    };
  }>;
}

export interface IStackedBarChart extends IBaseTileItem {
  colors: string[];
  series: Array<{
    name: string;
    data: number[];
  }>;
  series_colors: string[];
  categories: string[];
  config: {
    chart: {
      stackType: 'normal' | '100%'; // 'normal' | '100%';
    };
  };
}

export interface IDualBarChartData extends IBaseTileItem {
  title: string;
  list: string[];
  series: ApexAxisChartSeries;
  series_colors: string[];
}

export interface ILineChart extends IBaseTileItem {
  target: number;
  minValue: number;
  series: Array<{
    name: string;
    data: Array<{
      x: string;
      y: number;
      percentage: number;
    }>;
  }>;
}

export interface INGLineChart extends IBaseTileItem {
  colors: string[];
  series: Array<{
    name: string;
    stroke: boolean;
    data: number[];
  }>;
  categories: string[];
}

export interface IBulletList extends IBaseTileItem {
  title: string;
  list: Array<{
    order: number;
    text: string;
  }>;
}

export interface IUrlTileConfig {
  report: string;
  group?: string;
  accessToken?: string;
  reportType: 'CovidMap' | 'PBIReport' | 'ExternalLink';
  url?: string;
  pageName?: string;
}

export interface IUrlTile {
  title: string;
  imageUrl: string;
  cardRef: ICard;
  config: IUrlTileConfig;
}

export interface ITile {
  id: number;
  name: string;
  requiredUOM: string;
  cardTileTypeID: number;
  width: number;
  Tooltip?: {
    graphColorRanges: ITooltipGraphColorItem[];
  };
  itemStyle?: string;
  data:
    | ITextTileData
    | IRadialBarChartData
    | IKPIData
    | ITable
    | IStackedBarChart
    | ILineChart
    | IBulletList
    | IUrlTile
    | INGLineChart
    | IDynamicTileData;
}

export interface ITooltipGraphColorItem {
  Name: string;
  Colour: string;
  Message: string;
  MinValue: number;
  MaxValue: number;
  sortOrder: number;
}

export interface ICardHeader {
  indicator: string;
  title: string;
  district: string;
  period: string;
  bookmark: boolean;
  upload: boolean;
}

export interface ICardReward {
  icon: string;
  title: string;
}

export interface ICardRow {
  id: number;
  // cardID: number;
  noDivider: boolean;
  spaceBetween: boolean;
  sortOrder: number;
  tiles: ITile[];
}

export interface IBaseCard {
  id: number;
  boardId: number;
  cardID: number;
  languageID: number;
  instanceID: number;
  geoLevel: string;
  geoLocation: string;
  indicator: string;
  periodType: string;
  sortOrder: number;
  geoLocationHierarchy: IGeoLocationHierarchy[];
  isFocusCard: boolean;
  hasFocusBoard: boolean;
}

export interface ICardConfig {
  focusButtonTitle: string;
  indicatorClass: string;
  type: CardType;
  showButton: boolean;
  linkTitle?: string;
  showInNewTab?: boolean;
  config?: IUrlTileConfig;
}

export interface ICard extends IBaseCard {
  categoryID: number;
  questionID: number;
  cardIntentID: number;
  appID: number;
  cardHeading: string;
  question: string;
  title: string;
  iconName: string;
  period: string;
  bookmark: boolean;
  upload: boolean;
  hasProfilesLink?: boolean;
  link?: ICardLink;

  myFocusBoards: number[];

  rows: ICardRow[];
  reward?: ICardReward;
}

export interface ICardLink {
  question: string;
  appId: number;
  config: {
    reportId: string;
    groupId: string;
    filter?: string;
    pageName?: string;
  };
}

export interface IFocusBoard {
  id: number;
  instanceID: number;
  appID: number;
  boardTypeID: number;
  name: string;
}
export interface IGeoLocationHierarchy {
  geoLevel: string;
  geoLocation: string;
  hierachy: number;
}
